import LegalDocument from '../components/legal/LegalDocument';
import privacyPolicy from '../legal/privacyPolicyContent.json';

export default function PrivacyPolicyPage() {
  return <LegalDocument document={privacyPolicy} />;
}
